import { DefaultService } from '@/services/DefaultService';

export default class PropriedadeService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(propriedade) {
        return this._http.post(`${this._env}/agro/propriedade`, propriedade, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/propriedade/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    changeSituacao(id) {
        return this._http.delete(`${this._env}/agro/propriedade/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column, order, page = 0, limit = 50, situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/propriedade.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    listAll(limit = 50, idcliente, situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/propriedade/list.json?cliente=${idcliente}&limit=${limit}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    listAllByIdCliente(idcliente, limit = 50, page = 0, ...params) {
        return this._http.get(`${this._env}/agro/propriedade/listbyidcliente.json?idcliente=${idcliente}&limit=${limit}&page=${page}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    listAllByMultipleIdsClientes(idsClientes, limit = 50, page = 0, situacao = 2, ...params) {
        return this._http.post(`${this._env}/agro/propriedade/listbymultilpeclientes.json?limit=${limit}&page=${page}&situacao=${situacao}&param=${params}`, idsClientes, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(...params) {
        return this._http.get(encodeURI(`${this._env}/agro/propriedade/getcombo.json?param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}